import React from 'react';
import Menu from '../components/Menu/Menu';

const MenuPage = () => {
  return (
    <div className="main-content menu-page">
      <Menu />
    </div>
  );
};

export default MenuPage;